<template>
  <div>
    <b-alert variant="secondary" show>
      <div
        style="display: flex; align-items: end; justify-content: end"
        class="mb-1 alert-heading"
      >
        <!-- <p class="mb-1">Invoice Date Range :</p> -->
        <p class="mr-1"><b>Received Payment Date Range (current month):</b></p>
        <flat-pickr
          @input="onReportDate"
          v-model="reportDateRange"
          style="width: 400px"
          :config="{ mode: 'range', ...$flatPickrConfig, maxDate: new Date() }"
          placeholder="Select
      Month Range"
          class="form-control mr-1"
        />
        <b-button
          @click="showModal"
          class="mr-1"
          v-b-tooltip.hover
          title="apply filters"
          variant="secondary"
          size="sm"
          ><feather-icon style="cursor: pointer" icon="FilterIcon" size="23"
        /></b-button>
        <b-button
          v-b-tooltip.hover
          title="export as excel"
          variant="secondary"
          size="sm"
          @click="onExportExcel"
          ><feather-icon style="cursor: pointer" icon="DownloadIcon" size="23"
        /></b-button>
        <b-button
          style="margin-left: 1%"
          variant="secondary"
          @click="handleResetButtonClicked"
          >Reset</b-button
        >
      </div>
    </b-alert>
    <div v-if="filterApplied == true" style="margin-top: 2%; margin-bottom: 2%">
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedAccountArray.length > 0"
      >
        Account : {{ appliedFilters.selectedAccountArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedInvoiceArray.length > 0"
      >
        Invoice No : {{ appliedFilters.selectedInvoiceArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedInvDateRange"
      >
        Added Payment Date : {{ appliedFilters.selectedInvDateRange }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedLicensorArray.length > 0"
      >
        Licensor : {{ appliedFilters.selectedLicensorArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedCurrencyArray.length > 0"
      >
        Invoice Currency : {{ appliedFilters.selectedCurrencyArray.toString() }}
      </b-badge>
    </div>

    <div style="overflow-x: auto">
      <table ref="exportable_table">
        <tr style="background: lightgrey">
          <th>
            Account
            <hr />

            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>
            Invoice Number
            <hr />

            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>
            Licensor
            <hr />

            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>Invoice Dt.</th>
          <th>
            Added Payment Dt.
            <!-- <hr /> -->

            <!-- <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button> -->
          </th>

          <th>Amount Received</th>
          <th>Currency</th>

          <th>Payment Created Dt.</th>
          <th>Exchange Rate</th>
          <th>Amount (CHF)</th>
        </tr>
        <tr
          v-for="(item, index) in accountReceivableReportData"
          :key="index"
          :style="
            item.iban && item.iban.includes('Total')
              ? 'background:lightGrey;border-bottom:3px solid grey '
              : ''
          "
        >
          <td>{{ item.iban }}</td>
          <td>
            <a
              @click="
                () =>
                  (invId = item.revenue_invoice_id
                    ? item.revenue_invoice_id
                    : null)
              "
              v-b-modal.invModal
              ><u>{{ item.invoice_unique_id }}</u></a
            >
          </td>

          <td>{{ item.company }}</td>
          <td>
            {{ item.invDate ? item.invDate : "" }}
          </td>
          <td>{{ item.paidAmountDate ? item.paidAmountDate : "" }}</td>
          <td style="text-align: right">
            {{ formatCurrency(item.paidAmount) }}
          </td>
          <td>
            {{ item.selectedCurrency }}
          </td>

          <td>{{ item.paymentCreatedDate ? item.paymentCreatedDate : "" }}</td>
          <td>{{ item.exchange_rate ? formatExchangeRate(item.exchange_rate) : 1 }}</td>
          <td>
            {{
              formatCurrency(
                item.paidAmount * (item.exchange_rate ? item.exchange_rate : 1)
              )
            }}
          </td>
        </tr>
      </table>
    </div>
    <div>
      <b-modal
        no-close-on-backdrop
        ref="my-modal"
        hide-footer
        title="Report Filters"
      >
        <div class="d-block text-left">
          <b-form-group id="Account" label="Account">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedAccountArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="accountArray"
            />
          </b-form-group>
          <b-form-group id="Invoice" label="Invoice Numbers">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedInvoiceArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="invoiceNumbersArray"
            />
          </b-form-group>
          <b-form-group id="Licensor" label="Licensor">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedLicensorArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="licensorArray"
            />
          </b-form-group>
          <!-- <b-form-group label="Added Payment Date Range">
            <flat-pickr
              :config="{ mode: 'range', ...$flatPickrConfig }"
              placeholder="Select"
              class="form-control"
              v-model="filters.selectedInvDateRange"
            />
          </b-form-group> -->
          <b-form-group id="Currency" label="Currency">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedCurrencyArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="currencyArray"
            />
          </b-form-group>
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="onApplyFilters"
          >Apply Filters</b-button
        >
        <b-button variant="outline-info" block @click="handleResetButtonClicked"
          >Reset Filters</b-button
        >
      </b-modal>
    </div>
    <b-modal v-if="invId" size="xl" id="invModal" title="Invoice"
      ><preview-invoice :invId="invId" />
    </b-modal>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  VBTooltip,
  BModal,
  BFormGroup,
  BBadge,
  BAlert,
} from "bootstrap-vue";
import { GetReceivedStatementReport } from "@/apiServices/BookkeepingServices";
import moment from "moment";
import { formatCurrency,formatExchangeRate } from "@/utils/helpers";
import qs from "qs";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import PreviewInvoice from "@/views/pages/Revenue/PreviewInvoice.vue";
export default {
  data() {
    return {
      filterApplied: false,
      reportDateRange: null,
      reportFromDate: null,
      reportToDate: null,
      invoiceNumbersArray: [],
      licensorArray: [],
      currencyArray: [],
      accountArray: [],
      filters: {
        selectedAccountArray: [],
        selectedInvoiceArray: [],
        selectedLicensorArray: [],
        selectedCurrencyArray: [],
        selectedInvDateRange: null,
      },
      appliedFilters:{
        selectedAccountArray: [],
        selectedInvoiceArray: [],
        selectedLicensorArray: [],
        selectedCurrencyArray: [],
        selectedInvDateRange: null,
      },
      BASE_URL: process.env.VUE_APP_BASEURL,
      moment: moment,
      tabIndex: 0,
      accountReceivableReportData: [],
      actualAccountReceivableReportData: [],
      applyFilterClicked:false,
      invId: null,
    };
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BTabs,
    BTab,
    BCard,
    FeatherIcon,
    BButton,
    VBTooltip,
    vSelect,
    BModal,
    flatPickr,
    BFormGroup,
    BBadge,
    PreviewInvoice,
    BAlert,
  },
  // beforeMount() {
  //   this.filterApplied = false;
  //   let today = moment().format("YYYY-MM-DD");
  //   let previous = moment().startOf("month").format("YYYY-MM-DD");
  //   this.reportDateRange = previous + " to " + today;

  //   this.reportFromDate = moment().startOf("month").format("YYYY-MM-DD");
  //   this.reportToDate = moment().endOf("month").format("YYYY-MM-DD");
  //   this.getReceivedStatementReport();
  // },
  
  beforeMount() {
    this.filterApplied = false;

    // Get today's date
    const today = moment().format("YYYY-MM-DD");

    // Check if today is the 1st day of the month
    const isFirstDayOfMonth = moment().date() === 1;

    let previous;

    if (isFirstDayOfMonth) {
      // If today is the 1st day of the month, set `previous` to 15 days back from the start of the month
      previous = moment()
        .startOf("month")
        .subtract(15, "days")
        .format("YYYY-MM-DD");
    } else {
      // If today is not the 1st day of the month, set `previous` to the start of the current month
      previous = moment().startOf("month").format("YYYY-MM-DD");
    }

    this.reportDateRange = previous + " to " + today;
    this.reportFromDate = previous; 
    this.reportToDate = today; 
    this.getReceivedStatementReport();
  },
  methods: {
    formatCurrency,
    formatExchangeRate,
    handleResetButtonClicked() {
      this.filterApplied = false;
      localStorage.removeItem("filtersReportDateRangeRecievedStatementReport");
      localStorage.removeItem("recievedStatementReportFilters");
      // let today = moment().format("YYYY-MM-DD");
      // let previous = moment().startOf("month").format("YYYY-MM-DD");
      // this.reportDateRange = previous + " to " + today;

      // this.reportFromDate = moment().startOf("month").format("YYYY-MM-DD");
      // this.reportToDate = moment().endOf("month").format("YYYY-MM-DD");
      const isFirstDayOfMonth = moment().date() === 1;
      if(isFirstDayOfMonth){
        this.reportDateRange = `${moment().subtract(15, "days").format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")}`;
        this.reportFromDate = moment().subtract(15, "days").format("YYYY-MM-DD");
        this.reportToDate = moment().format("YYYY-MM-DD");
      }
      else {
        this.reportDateRange = `${moment().startOf("month").format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")}`;
        this.reportFromDate = moment().startOf("month").format("YYYY-MM-DD");
        this.reportToDate = moment().format("YYYY-MM-DD");
      }
      this.filters = {
        selectedAccountArray: [],
        selectedInvoiceArray: [],
        selectedLicensorArray: [],
        selectedCurrencyArray: [],
      };
      this.invoiceNumbersArray = [];
      this.licensorArray = [];  
      this.currencyArray = [];
      this.accountArray = [];
      this.getReceivedStatementReport();
    },
    delay() {
      return new Promise((resolve) => setTimeout(resolve, 1000));
    },

    onReportDate() {
      if (this.reportDateRange) {
        let from = null;
        let to = null;
        const today = new Date();
        const isFirstDayOfMonth = today.getDate() === 1;

        // if (isFirstDayOfMonth) {
        //   // If today is the 1st day of the month, set `from` to 15 days back
        //   from = new Date(today);
        //   from.setDate(today.getDate() - 15);

        //   // Set `to` to today
        //   to = new Date(today);

        //   // Update the reportDateRange to reflect the new range
        //   this.reportDateRange = `${from.toISOString().split("T")[0]} to ${
        //     to.toISOString().split("T")[0]
        //   }`;
        // } else {
        //   // If not the 1st day of the month, proceed with the original logic
        //   if (this.reportDateRange.split("to").length > 1) {
        //     from = new Date(this.reportDateRange.split("to")[0]);
        //     to = new Date(this.reportDateRange.split("to")[1]);
        //   } else {
        //     from = new Date(this.reportDateRange.split("to")[0]);
        //     to = new Date(this.reportDateRange.split("to")[0]);
        //   }
        // }
        from = this.reportDateRange.split("to")[0];
        to = this.reportDateRange.split("to")[1];

        // Format the `from` and `to` dates
        // this.reportFromDate = `${from.getFullYear()}-${(
        //   "0" +
        //   (from.getMonth() + 1)
        // ).slice(-2)}-${("0" + from.getDate()).slice(-2)}`;
        this.reportFromDate = from

        // this.reportToDate = moment(to).add(1, "days").format("YYYY-MM-DD");
        this.reportToDate = to

        // Save the updated reportDateRange to local storage
        localStorage.setItem(
          "filtersReportDateRangeRecievedStatementReport",
          JSON.stringify({
            reportDateRange: this.reportDateRange,
            // pagination: this.pagination,
          })
        );

        console.log("Value saved to local storage:", {
          reportDateRange: this.reportDateRange,
        });
        this.invoiceNumbersArray = [];
        this.licensorArray = [];
        this.currencyArray = [];
        this.accountArray = [];
        this.getReceivedStatementReport();
      }
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    onExportExcel() {
      let url = null;
      let excelName = "";
      let payload = {
        accountReceivableReportData: this.accountReceivableReportData,
        invNumbers: this.filters.selectedInvoiceArray
          ? this.filters.selectedInvoiceArray.toString()
          : "",
        licensor: this.filters.selectedLicensorArray
          ? this.filters.selectedLicensorArray.toString()
          : "",
        invDtRange: this.filters.selectedInvDateRange,
        account: this.filters.selectedAccountArray
          ? this.filters.selectedAccountArray.toString()
          : "",
      };

      url = this.BASE_URL + `/bookkeeping/exportReceivedStatementReport`;

      fetch(url, {
        method: "POST",
        headers: {
          "content-type": "application/Json",
          authorization: localStorage.getItem("access_token"),
          "x-access-token": localStorage.getItem("access_token"),
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.blob())
        .then((blob) => {
          const anchorElement = document.createElement("a");
          document.body.appendChild(anchorElement);
          anchorElement.style.display = "none";
          excelName = "ReceivedStatementReport.xlsx";
          var url = window.URL.createObjectURL(blob);
          anchorElement.href = url;
          anchorElement.download = excelName;
          anchorElement.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err, "error in onExportExcel");
        });
    },

    // async getReceivedStatementReport() {

    //   try {
    //     this.accountReceivableReportData = [];
    //     const response = await GetReceivedStatementReport({
    //       reportFromDate: this.reportFromDate,
    //       reportToDate: this.reportToDate,
    //       filters: this.filters,
    //     });

    //     if (response.data.status) {
    //       let addedInv = [];
    //       let addedLicensor = [];
    //       let addedCurrency = [];
    //       let addedAcc = [];

    //       for (let item of this.accountReceivableReportData) {
    //         if (
    //           item.invoice_unique_id &&
    //           item.invoice_unique_id !== "Total" &&
    //           item.invoice_unique_id !== "Grand Total"
    //         ) {
    //           if (!addedInv.includes(item.invoice_unique_id)) {
    //             let obj = {
    //               id: item.invoice_unique_id,
    //               value: item.invoice_unique_id,
    //             };

    //             const isDuplicateInvoiceNumbers = this.invoiceNumbersArray.some(
    //               (existingItem) => existingItem.id === item.invoice_unique_id
    //             );

    //             if (!isDuplicateInvoiceNumbers) {
    //               this.invoiceNumbersArray.push(obj);
    //               addedInv.push(item.invoice_unique_id);
    //             }
    //           }

    //           if (!addedLicensor.includes(item.vendor_id)) {
    //             let obj1 = {
    //               id: item.company,
    //               value: item.company,
    //             };

    //             const isDuplicateLicensorArray = this.licensorArray.some(
    //               (existingItem) => existingItem.id === item.company
    //             );

    //             if (!isDuplicateLicensorArray) {
    //               this.licensorArray.push(obj1);
    //               addedLicensor.push(item.company);
    //             }
    //           }

    //           if (
    //             item.selectedCurrency &&
    //             !addedCurrency.includes(item.selectedCurrency)
    //           ) {
    //             let obj2 = {
    //               id: item.selectedCurrency,
    //               value: item.selectedCurrency,
    //             };

    //             const isDuplicateCurrencyArray = this.currencyArray.some(
    //               (existingItem) => existingItem.id === item.selectedCurrency
    //             );

    //             if (!isDuplicateCurrencyArray) {
    //               this.currencyArray.push(obj2);
    //               addedCurrency.push(item.selectedCurrency);
    //             }
    //           }

    //           if (item.iban && !addedAcc.includes(item.iban)) {
    //             let obj3 = {
    //               id: item.iban,
    //               value: item.iban,
    //             };

    //             const isDuplicateAccountArray = this.accountArray.some(
    //               (existingItem) => existingItem.id === item.iban
    //             );

    //             if (!isDuplicateAccountArray) {
    //               this.accountArray.push(obj3);
    //               addedAcc.push(item.iban);
    //             }
    //           }
    //         }
    //       }
    //     } else {
    //       console.warn(`No data received after ${maxAttempts} attempts.`);
    //     }
    //   } catch (error) {
    //     console.error("Error in getReceivedStatementReport", error);
    //   }
    // },

    async getReceivedStatementReport() {
      try {
        this.accountReceivableReportData = [];
        const response = await GetReceivedStatementReport({
          reportFromDate: this.reportFromDate,
          reportToDate: this.reportToDate,
          filters: this.filters,
        });
        if (response.data.status) {
          this.accountReceivableReportData = response.data.data;
          this.actualAccountReceivableReportData = response.data.data;

          let addedInv = [];
          let addedLicensor = [];
          let addedCurrency = [];
          let addedAcc = [];
          for (let item of this.accountReceivableReportData) {
            if (
              item.invoice_unique_id &&
              item.invoice_unique_id != "Total" &&
              item.invoice_unique_id != "Grand Total"
            ) {
              if (!addedInv.includes(item.invoice_unique_id)) {
                let obj = {
                  id: item.invoice_unique_id,
                  value: item.invoice_unique_id,
                };
                const isDuplicateInvoiceNumbers = this.invoiceNumbersArray.some(
                  (existingItem) => existingItem.id === item.invoice_unique_id
                );

                if (!isDuplicateInvoiceNumbers) {
                  this.invoiceNumbersArray.push(obj);
                  addedInv.push(item.invoice_unique_id);
                }
              }
              if (!addedLicensor.includes(item.company)) {
                let obj1 = {
                  id: item.company,
                  value: item.company,
                };
                const isDuplicateLicensorArray = this.licensorArray.some(
                  (existingItem) => existingItem.id === item.company
                );

                if (!isDuplicateLicensorArray) {
                  this.licensorArray.push(obj1);
                  addedLicensor.push(item.company);
                }
              }
              if (item.selectedCurrency) {
                if (!addedCurrency.includes(item.selectedCurrency)) {
                  let obj2 = {
                    id: item.selectedCurrency,
                    value: item.selectedCurrency,
                  };
                  const isDuplicateCurrencyArray = this.currencyArray.some(
                    (existingItem) => existingItem.id === item.selectedCurrency
                  );

                  if (!isDuplicateCurrencyArray) {
                    this.currencyArray.push(obj2);
                    addedCurrency.push(item.selectedCurrency);
                  }
                }
              }

              if (item.iban) {
                if (!addedAcc.includes(item.iban)) {
                  let obj3 = {
                    id: item.iban,
                    value: item.iban,
                  };
                  const isDuplicateAccountArray = this.accountArray.some(
                    (existingItem) => existingItem.id === item.iban
                  );

                  if (!isDuplicateAccountArray) {
                    this.accountArray.push(obj3);
                    addedAcc.push(item.iban);
                  }
                }
              }
            }
          }
        }
        console.log(response, "response");
      } catch (error) {
        console.log("Error in getReceivedStatementReport", error);
      }
    },
    onApplyFilters() {
      this.filterApplied = true;
      this.applyFilterClicked = true;
      this.appliedFilters = JSON.parse(JSON.stringify(this.filters))
      localStorage.setItem(
        "recievedStatementReportFilters",
        JSON.stringify(this.appliedFilters)
      );
      this.getReceivedStatementReport();
      this.$refs["my-modal"].hide();
    },

    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-outline-primary", "text-info"];
      }
    },
    loadRecievedStatementFilters() {
      let localRecievedFilters = localStorage.getItem(
        "recievedStatementReportFilters"
      );
      if (localRecievedFilters) {
        this.filters = JSON.parse(localRecievedFilters);
        this.appliedFilters = this.filters ;
      }
      if (
        this.filters.selectedAccountArray.length > 0 ||
        this.filters.selectedInvoiceArray.length > 0 ||
        this.filters.selectedLicensorArray.length > 0 ||
        this.filters.selectedCurrencyArray.length > 0
      ) {
        this.filterApplied = true;
      }
    },
    loadReportToDateData() {
      const reportDateRange = localStorage.getItem(
        "filtersReportDateRangeRecievedStatementReport"
      );
      if (reportDateRange) {
        const obj = JSON.parse(reportDateRange);
        // this.pagination = obj.pagination;
        this.reportDateRange = obj.reportDateRange;
        this.$forceUpdate();
      }
      console.log(`The date range is ${this.reportDateRange}`);
    },
  },
  mounted() {
    this.loadReportToDateData();
    this.loadRecievedStatementFilters();
  },
};
</script>

<style lang="scss" scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  color: #000;
  border: 2px solid #dddddd;
  text-align: left;
  padding: 8px;
  font-weight: 400;
}
tr:hover {
  background-color: yellow;
}
</style>
